import { ChordProRenderer } from "@bandwith/songs";
import { CheckboxToggle, TransposeControl } from "@bandwith/ui";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Minimize2 } from "lucide-react";
import { songQuery } from "../lib/queries";
import { useShowChords } from "../lib/useShowChords";
import { useTranspose } from "../lib/useTranspose";
import { songNotesRoute } from "../router";

export function SongNotes() {
  const { id } = songNotesRoute.useParams();
  const { from } = songNotesRoute.useSearch();
  const { showChords, mounted, handleToggle } = useShowChords();
  const { transpose, handleChange: handleTransposeChange } = useTranspose(id);

  const { data: song, isLoading, error } = useQuery(songQuery(id));

  if (isLoading) {
    return <div className="text-text-muted">Loading...</div>;
  }

  if (error || !song || "error" in song) {
    return (
      <div>
        <p className="text-red-muted">Song not found</p>
        <Link to="/" className="text-amber hover:underline">
          Back to songs
        </Link>
      </div>
    );
  }

  const content = song.notes || "";

  // Avoid hydration mismatch by not rendering checkbox until mounted
  if (!mounted) {
    return <ChordProRenderer content={content} />;
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <h2 className="font-mono text-xs font-medium uppercase tracking-widest text-text-muted">
          <Link
            to="/songs/$id"
            params={{ id }}
            search={from ? { from } : {}}
            className="inline-flex items-center gap-1.5 transition-colors hover:text-amber"
            title="Back to song"
          >
            Notes
            <Minimize2 className="h-3 w-3" aria-hidden="true" />
          </Link>
        </h2>
        <div className="flex items-center gap-3">
          {showChords && (
            <TransposeControl
              value={transpose}
              onChange={handleTransposeChange}
            />
          )}
          <CheckboxToggle
            checked={showChords}
            onChange={handleToggle}
            label="Chords"
          />
        </div>
      </div>
      <ChordProRenderer
        content={content}
        showChords={showChords}
        transpose={transpose}
      />
    </div>
  );
}
